(function () {
    'use strict';

    angular.module('gallery')
        .controller('GalleryController', [
            '$scope',
            'GalleryService',
            function ($scope, GalleryService) {
                $scope.listMaximized = true;
                $scope.object = GalleryService.getCurrentObject();
            }]
        );
})();
